"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reduxPersist = require("redux-persist");

var _storage = _interopRequireDefault(require("redux-persist/lib/storage"));

var _initialState = _interopRequireDefault(require("./initialState"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var exportHTML = function exportHTML(state) {
  return ["<div id=\"emthemesModezBannersBlockHome02\" class=\"emthemesModez-section emthemesModez-section--banners-one\">", "<div class=\"emthemesModez-section-inner\">", "<div class=\"emthemesModez-bannersContainer emthemesModez-bannersContainer--one emthemesModez-bannersContainer--one-1\">"].concat(_toConsumableArray(state.items.map(function (id) {
    return state.itemsById[id];
  }).map(function (_ref) {
    var link = _ref.link,
        img = _ref.img,
        alt = _ref.alt,
        text = _ref.text,
        type = _ref.type;
    return type === 'banner' ? "  <div class=\"emthemesModez-banner\"><div class=\"emthemesModez-banner-container\"><a href=\"".concat((0, _utils.htmlEntities)(link), "\"><img class=\"emthemesModez-banner-image\" src=\"").concat((0, _utils.htmlEntities)(img), "\" alt=\"").concat((0, _utils.htmlEntities)(alt), "\" title=\"").concat((0, _utils.htmlEntities)(alt), "\" /></a></div></div>") : "  <div class=\"emthemesModez-banner\"><div class=\"emthemesModez-banner-container\">".concat(text, "</div></div>");
  })), ["</div>", "</div>", "</div>"]).join('\n');
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var _ref2 = action.payload || {},
      id = _ref2.id,
      payload = _objectWithoutProperties(_ref2, ["id"]);

  switch (action.type) {
    case 'ADD_ITEM':
      id = state.itemNextId;
      return _objectSpread(_objectSpread({}, state), {}, {
        items: [].concat(_toConsumableArray(state.items), [id]),
        itemsById: _objectSpread(_objectSpread({}, state.itemsById), {}, _defineProperty({}, id, _objectSpread({
          id: id
        }, payload))),
        itemNextId: id + 1
      });

    case 'UPDATE_ITEM':
      return _objectSpread(_objectSpread({}, state), {}, {
        itemsById: _objectSpread(_objectSpread({}, state.itemsById), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, state.itemsById[id]), payload)))
      });

    case 'DELETE_ITEM':
      var newItems = state.items.filter(function (_id) {
        return _id !== id;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        items: newItems,
        itemsById: newItems.reduce(function (newItemsById, id) {
          return _objectSpread(_objectSpread({}, newItemsById), {}, _defineProperty({}, id, state.itemsById[id]));
        }, {}),
        itemNextId: Math.max.apply(Math, _toConsumableArray(newItems)) + 1
      });

    case 'UPDATE_STATE':
      return _objectSpread(_objectSpread({}, state), action.payload);

    case 'EXPORT_CODE':
      return _objectSpread(_objectSpread({}, state), {}, {
        exportedHTML: exportHTML(state)
      });

    case 'RESET_STATE':
      return (0, _initialState["default"])();

    default:
      return state;
  }
};

var persistConfig = {
  key: 'HomeFullwidthBannerBuilderComponent',
  storage: _storage["default"]
};

var _default = (0, _redux.combineReducers)({
  HomeFullwidthBannerBuilderComponent: (0, _reduxPersist.persistReducer)(persistConfig, reducer)
});

exports["default"] = _default;